/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
type Config = {
	apiUrl: string;
	translationsVersion: string;
	splitIOApiKey: string;
	gaCode: string;
	server3Url: string;
	env: string;
	assetsBasePath: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function getConfig(): Config {
	return window.config;
}
